<template>
    <div class="page bgcolorCream">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="faqList" id="faqList">
                        <div
                            class="faqEl closed"
                            v-for="(faq,index) in faqs"
                            :class="{open: openedIndex === index}"
                            @click="openedIndex = index"
                        >
                            <div class="quest d-flex align-items-start">
                                <div>
                                    {{ index }}
                                </div>
                                <div>
                                    <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1.41 0.840088L6 5.42009L10.59 0.840088L12 2.25009L6 8.25009L0 2.25009L1.41 0.840088Z" fill="#653334"/>
                                    </svg>
                                </div>
                                
                            </div>
                            <div class="answer">
                                {{ faq }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
       
    </div>
</template>

<script>
    export default {
        name: "faqs",
        data(){
          return{
              openedIndex: -1,
              faqs: {
                  "Can I Use My App or Card At Any Location?" : "Yes, you can use your Kettlemans app or card at any of our locations.",
                  "How Do I Earn Points?" : "For every dollar you spend, you earn a point. Earn 100 points, and you can redeem $10 off a purchase. On your birthday, you will receive 100 points (a $10 value), provided you have been registered for loyalty for at least 30 days.",
                  "How Can I Track My Progress Towards Rewards? " : "On the app’s home screen, you’ll see your accumulated and available points to apply to a mobile order or order in store. You can also see your other available redemptions.",
                  "How Does Mobile Ordering Work?" : "Start an order in the app, choose a location to pick up from, and we’ll have your order ready and waiting for you, with your name on it, when you arrive. It’s just like a regular transaction in store, only you’re doing it on your phone and coming to pick it up.",
                  "Where Can I View A Past Transaction?" : "Start an order in the app, choose a location to pick up from, and we’ll have your order ready and waiting for you, with your name on it, when you arrive. It’s just like a regular transaction in store, only you’re doing it on your phone and coming to pick it up.",
                  "How Does Mobile Ordering Work?" : "Hit the hamburger menu in the top right hand corner of the app and you’ll see a menu pop up from the left. Hit Transaction History and you’ll see all of your recent transactions and the points you earned on each.",
                  "How Do E-Gifts Work?" : "You can send another person registered on the loyalty app an e-gift directly from you app. Hit the hamburger menu and click E-gifts. Enter their details and yours, select an amount, and submit. They’ll receive an email indicating a gift is in their app ready to use.",
              }
          }
        },
        created() {
            this.$store.commit("shared/setTopBar", {title: "Help", showBackButton: false, showBag: false}, {root: true});
        }
    }
</script>
